import React, { useState } from 'react';
import Select, { components } from 'react-select';

const FONT = 'Inter, system-ui, sans-serif';
interface Props {
    selected: string | string[];
    label: string;
    options: Array<any>;
    onSelect: (val: string | string[]) => void;
    menuWidth?: number | string;
    menuAlign?: 'left' | 'right';
    isMulti?: boolean;
}
const SingleSelectDropdown: React.FC<Props> = React.memo((props) => {
    const [selectedValue, setSelectedValue] = useState<any>(props.isMulti ? [] : null);
    const [menuOpen, setMenuOpen] = useState(false);
    function handleSelect(val: any) {
        setSelectedValue(val);
        if (props.isMulti) {
            props.onSelect((val || []).map((v: any) => v.value));
        } else {
            props.onSelect(val.value);
        }
    }
    return (
        <>
            {menuOpen && (
                <div
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9998 }}
                    onClick={() => setMenuOpen(false)}
                />
            )}
            <Select
                options={props.options}
                isMulti={props.isMulti ?? false}
                value={selectedValue}
                onChange={(val: any) => handleSelect(val)}
                placeholder={props.label}
                menuIsOpen={menuOpen}
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                closeMenuOnSelect={!props.isMulti}
                hideSelectedOptions={false}
            components={props.isMulti ? {
                Menu: ({ children, ...menuProps }: any) => (
                    <components.Menu {...menuProps}>
                        {children}
                        <div style={{
                            display: 'flex', justifyContent: 'flex-end',
                            padding: '6px 8px', borderTop: '1px solid #e0e0e0',
                        }}>
                            <button
                                type="button"
                                onMouseDown={(e) => { e.preventDefault(); setMenuOpen(false); }}
                                style={{
                                    background: '#4BB75F', color: '#fff', border: 'none',
                                    borderRadius: 12, padding: '3px 14px', fontSize: 12,
                                    cursor: 'pointer', fontWeight: 600, letterSpacing: 0.3,
                                    fontFamily: FONT,
                                }}
                            >
                                Done ✓
                            </button>
                        </div>
                    </components.Menu>
                ),
                Option: (optionProps: any) => (
                    <components.Option {...optionProps}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{
                                width: 16, height: 16, borderRadius: 3, border: '2px solid #4BB75F',
                                backgroundColor: optionProps.isSelected ? '#4BB75F' : 'transparent',
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                {optionProps.isSelected && (
                                    <span style={{ color: '#fff', fontSize: 11, lineHeight: 1 }}>✓</span>
                                )}
                            </span>
                            {optionProps.label}
                        </span>
                    </components.Option>
                ),
                ValueContainer: ({ children, getValue, ...rest }: any) => {
                    const count = getValue().length;
                    const [, input] = React.Children.toArray(children);
                    return (
                        <components.ValueContainer {...rest} getValue={getValue}>
                            {count > 0
                                ? <span style={{ padding: '2px 6px' }}>{count} package{count > 1 ? 's' : ''} selected</span>
                                : children}
                            {count > 0 && input}
                        </components.ValueContainer>
                    );
                },
            } : undefined}
            styles={{
                control: (base: any) => ({
                    ...base,
                    minWidth: 180,
                    maxWidth: 240,
                    borderColor: '#4BB75F',
                    boxShadow: 'none',
                    fontFamily: FONT,
                    '&:hover': { borderColor: '#4BB75F' },
                }),
                option: (base: any, state: any) => ({
                    ...base,
                    backgroundColor: state.isSelected
                        ? '#4BB75F'
                        : state.isFocused
                            ? '#E8F5E9'
                            : 'transparent',
                    color: state.isSelected ? '#fff' : '#102B27',
                    cursor: 'pointer',
                    borderBottom: '1px solid #fff',
                    fontFamily: FONT,
                }),
                placeholder: (base: any) => ({ ...base, fontFamily: FONT }),
                singleValue: (base: any) => ({ ...base, fontFamily: FONT }),
                input: (base: any) => ({ ...base, fontFamily: FONT }),
                menuList: (base: any) => ({ ...base, fontFamily: FONT }),
                menu: (provided: any) => ({
                    ...provided,
                    minWidth: props.menuWidth ?? 'max-content',
                    whiteSpace: 'nowrap' as any,
                    fontFamily: FONT,
                    ...(props.menuAlign === 'right' ? { right: 0, left: 'auto' } : {}),
                }),
                menuPortal: (provided: any) => ({
                    ...provided,
                    zIndex: 9999,
                }),
            }}
            menuPortalTarget={document.body}
            />
        </>
    );
})

export { SingleSelectDropdown }